/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFlag2Off = createReactComponent("outline", "flag-2-off", "IconFlag2Off", [["path", { "d": "M5 14h9m4 0h1v-9h-10m-4 0v16", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

export { IconFlag2Off as default };
//# sourceMappingURL=IconFlag2Off.mjs.map
